import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from 'src/tabs/constants/Common.constants';

export const dateFilterMapper = (
  date: Date | string,
  filterType: string,
  currentYear?: number
) => {
  if (date === 'Full Year') {
    return `&startDate=${currentYear}-01-01&endDate=${currentYear}-12-31`;
  } else if (date !== 'Full Year') {
    const year = moment(date).format('YYYY');
    const formattedStartDate = moment(date).format(DEFAULT_DATE_FORMAT);
    const formattedEndDate = moment(date).endOf('month').format(DEFAULT_DATE_FORMAT);
    switch (filterType) {
      case 'In':
        return `&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
      case 'In or before':
        return `&startDate=${year}-01-01&endDate=${formattedEndDate}`;
      case 'In or after':
        return `&startDate=${formattedStartDate}&endDate=${year}-12-31`;
      default:
        return `&startDate=${year}-01-01&endDate=${year}-12-31`;
    }
  }
};
